// Shared page SEO helpers for title, description, and keywords.

function upsertMeta(name, content) {
   let el = document.querySelector(`meta[name="${name}"]`);
   if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
   }
   el.setAttribute("content", content);
}

// Apply document title plus description/keywords meta tags.
export function setPageSeo({ title, description, keywords }) {
   if (title) document.title = title;
   if (description) upsertMeta("description", description);
   if (keywords) upsertMeta("keywords", keywords);
}
